module.exports = __webpack_public_path__ + "img/bingoScreenshot.d4fa6d4b.png";